import { ref } from 'vue';

export const isSaving = ref(false);
export const isDeleting = ref(false);
export const errorMessage = ref('');
export const undoUrl = ref('');
const undoTimeout = ref(null);

export function setError(message) {
    if (message) {
        errorMessage.value = message;
    } else {
        errorMessage.value = 'Server error.';
    }
    isSaving.value = false;
    isDeleting.value = false;
    undoUrl.value = '';
    if (undoTimeout.value) {
        clearTimeout(undoTimeout.value);
    }
}

export function startDeleting(restoreUrl) {
    isDeleting.value = true;
    if (restoreUrl) {
        undoUrl.value = restoreUrl;
        undoTimeout.value = setTimeout(() => {
            undoUrl.value = false;
        }, 5000); // ensures user sees undo button for at least 5 seconds
    }
}
